module.exports = __webpack_public_path__ + "media/images/babel.config-d59cae1decaf0d845b296e63bbdf6b31.jpg";